/**
 * ============================================================================
 * [P6-05] TrackingPostList - 트래킹 포스트 목록
 *
 * 기능:
 * - 포스트 카드 목록 표시
 * - 빈 상태 처리
 * - 로딩 상태 처리
 * ============================================================================
 */

import type { TrackingPost } from '@/types'
import { TrackingPostCard } from './TrackingPostCard'
import styles from './Tracking.module.css'

// ============================================================================
// Props 타입 정의
// ============================================================================
interface TrackingPostListProps {
  posts: TrackingPost[]
  isLoading: boolean
  onEdit: (post: TrackingPost) => void
  onDelete: (id: string) => void
  onToggleFavorite: (id: string) => void
  onToggleActive: (id: string) => void
  onAddMetric: (postId: string) => void
  onManageMetrics?: (post: TrackingPost) => void  // [P6-05] 메트릭 관리 모달 열기
}

// ============================================================================
// [P6-05] TrackingPostList Component
// ============================================================================
export function TrackingPostList({
  posts,
  isLoading,
  onEdit,
  onDelete,
  onToggleFavorite,
  onToggleActive,
  onAddMetric,
  onManageMetrics,  // [P6-05] 메트릭 관리 모달 열기
}: TrackingPostListProps) {
  // ========================================================================
  // 로딩 상태
  // ========================================================================
  if (isLoading) {
    return (
      <div className={styles.postListLoading}>
        <span>포스트를 불러오는 중...</span>
      </div>
    )
  }

  // ========================================================================
  // 빈 상태
  // ========================================================================
  if (posts.length === 0) {
    return (
      <div className={styles.postListEmpty}>
        <div className={styles.emptyIcon}>@</div>
        <h3>등록된 포스트가 없습니다</h3>
        <p>SNS 포스트를 추가하고 메트릭을 트래킹해보세요.</p>
      </div>
    )
  }

  // ========================================================================
  // Render
  // ========================================================================
  return (
    <div className={styles.postList}>
      {posts.map((post) => (
        <TrackingPostCard
          key={post.id}
          post={post}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleFavorite={onToggleFavorite}
          onToggleActive={onToggleActive}
          onAddMetric={onAddMetric}
          onManageMetrics={onManageMetrics}  // [P6-05] 메트릭 관리 모달 전달
        />
      ))}
    </div>
  )
}

export default TrackingPostList
